<template>
  <div :class="[ 'menu', { 'menu--opened':opened, 'menu--docked':docked  }]">
    <div class="menu__bg"></div>
    <div class="menu__logo">
      <router-link to="/"><img src="/images/logo-black.png" class="rs"></router-link>
    </div>
    <div class="menu__burger" v-on:click="toggle">
      <span>MENU</span>
      <div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="menu__wrapper">
      <div class="menu__bgblack desktop" v-on:click="close"></div>
      <div class="menu__container">
        <ul>
          <li>
            <div><router-link to="/" :class="isActive('/')">Accueil</router-link></div>
          </li>
          <li>
            <div><router-link to="/agenda" :class="isActive('/agenda')">Agenda</router-link></div>
          </li>
          <li>
            <div><router-link to="/identite" :class="isActive('/identite')">Identité</router-link></div>
          </li>
          <li>
            <div><router-link to="/la-plage" :class="isActive('/la-plage')">La Plage</router-link></div>
          </li>
          <li>
            <div><a href="" v-on:click.prevent="openPopin" class="link-popin link-popin--mecene">Mécènes</a></div>
          </li>
        </ul>

        <a href="https://billetterie.gtg.ch/list/events" target="_blank" class="round-button round-button--menu round-button--white">Billetterie</a>

        <div class="menu__footer row desktop">
          <div class="col--mid">
            Grand Théâtre de Genève<br>
            Case Postale 5126<br>
            CH–1211 Genève 11
          </div>
          <div class="col--mid">
            Administration +41 22 322 50 00<br>
            Billetterie +41 22 322 50 50
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.menu{
  position: fixed;
  z-index: 100;
  width: 100%;

  &__bg{
    position: absolute;
    width: 100%;
    height: 18rem;
    background-color: white;
    opacity: 0;
    transition: all .3s ease;
    @media #{$bp-sm}{
      height: 13rem;
    }
    .menu--docked & {
      opacity: .8;
      transform: translate3d(0,-4rem,0);
      @media #{$bp-sm}{
        transform: translate3d(0,-2rem,0);
      }
    }
    .menu--opened & {
      opacity: 0;
    }
  }

  &__logo{
    position: absolute;
    transition: all .3s ease;
    .menu--docked &{
      transform: translate3d(0,-4rem,0);
      @media #{$bp-sm}{
        transform: translate3d(0,-2rem,0);
      }
    }

    @media #{$bp-sm}{
      margin-top: 3.8rem;
      width: 10.7rem;
      left: 3rem;
    }

    @media #{$bp-sm-up}{
      margin-top: 7rem;
      width: $col-size;
      margin-left: $col-size;
    }
  }
  &__burger{
    font-size: 14px;
    position: absolute;
    cursor: pointer;
    z-index: 10;
    transition: all .3s ease;

    @media #{$bp-sm}{
      margin-top: 6.5rem;
      right: 4rem;
    }

    @media #{$bp-sm-up}{
      left: $col-size * 5;
      margin-left: -7rem;
      margin-top: 10rem;
    }

    .menu--opened &{
      color: white;
    }
    .menu--docked &{
      transform: translate3d(0,-4rem,0);
      @media #{$bp-sm}{
        transform: translate3d(0,-2rem,0);
      }
    }


    > div{
      display: inline-block;
      margin-left: 28px;
      > div{
        width: 18px;
        height: 2px;
        background-color: black;
        margin-bottom: 3px;
        transition: all .3s ease;
        &:last-child{
          margin-bottom: 0; 
        }

        .menu--opened &{
          background-color: white;
          &:nth-child(1){
            transform: translateY(5px) rotate(45deg);
          }
          &:nth-child(2){
            opacity: 0;
          }
          &:nth-child(3){
            transform: translateY(-5px) rotate(-45deg);
          }
        }
      }
    }
  }

  &__wrapper{
    position: absolute;
    width: 100%;
    height: 100vh;
    // background-color: rgba(0,0,0,0.7);
    // opacity: 0;
    // transition: opacity .4s ease;
    pointer-events: none;

    .menu--opened &{
      // opacity: 1;
      pointer-events: auto;
    }
  }

  &__bgblack{
    position: absolute;
    width: 100%;
    height: 100vh;
    background-color: rgba(0,0,0,0.7);
    opacity: 0;
  }

  &__container{
    background-color: black;
      position: absolute;
    @media #{$bp-sm}{
      padding: 4rem;
      padding-top: 13rem;
      bottom: 100%;
      width: 100%;
    }
    @media #{$bp-sm-up}{
      padding: $col-size;
      width: 50%;
      height: 100%;
      left: 100%;   
    }

    ul{
      padding: 0;
      list-style: none;
      font-size: 0;

      li{
        > div{
          overflow:hidden;
          > a{
            display: inline-block;
            transform: translate3d(0,110%,0);
          }
        }
      }

      a{
        color: white;
        font-size: 6rem;
        font-weight: 500;
        line-height: 6.4rem;
        text-decoration: none;
        text-transform: uppercase;
        color: #424242;
        transition: color .3s ease;
        @media #{$bp-sm}{
          font-size: 4.8rem;
          line-height: 5.6rem;
        }
        &:hover{
          color: white;
        }
        &.active{
          @include SERIF;
          font-size: 7.2rem;
          color: white;
          @media #{$bp-sm}{
            font-size: 4.8rem;
            line-height: 5.6rem;
          }
        }
      }
    }
  }

  .round-button{
    opacity:0;
  }

  &__footer{
    white-space: nowrap;
    position: absolute !important;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0 $col-size * 2;
    padding-bottom: $col-size * 2;
    line-height: 26px;
    color: white;
    @include TIMES;

    opacity: 0;
  }
}
</style>

<script>
import TimelineMax from 'gsap/TimelineMax'
import TweenMax from 'gsap/TweenMax'

export default {
  data() {
    return {
      opened: false,
      docked: false,
      currentRoute: ''
    };
  },
  methods: {
    toggle(){
      this.opened = !this.opened
      if( this.opened ) this.open()
      else this.close()
    },
    open(){
      this.tl.timeScale = 1
      this.tl.play()
    },
    close(){
      this.opened = false
      this.tl.timeScale = 3
      this.tl.reverse()
    },
    isActive(url){
      if( url == this.currentRoute ){
        return 'active'
      }else{
        return ''
      }
    },
    getScrollTop(){
      return window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0)
    },
    openPopin(){
      this.$store.commit('openPopin', 'mecene')
    }
  },
  watch:{
    $route (to, from){
      this.nextCurrentRoute = to.path
      this.close()
    }
  },
  mounted() {
    this.currentRoute = this.$route.path
    let scrollHandler = ()=>{
      this.docked = this.getScrollTop() > 100
    }
    window.addEventListener('scroll', scrollHandler )


    let complete = ()=>{
      setTimeout(()=>{
        if(! this.opened ){
          if( this.nextCurrentRoute ){
            this.currentRoute = this.nextCurrentRoute  
          }
        }
      
      }, 200 )
    }
    this.tl = new TimelineMax({
      onComplete : complete,
      onReverseComplete : complete
    })

    this.tl.to( this.$el.querySelector('.menu__bgblack'), 1.2, { ease: Cubic.easeInOut, opacity: 1 } )
    
    if( window.innerWidth <= 768 ){
      this.tl.to( this.$el.querySelector('.menu__container'), 1.2, { ease: Quart.easeInOut, y: '100%' }, 0 )
    }else{
      this.tl.to( this.$el.querySelector('.menu__container'), 1.2, { ease: Quart.easeInOut, x: '-100%' }, 0 )
    }

    this.tl.staggerTo( '.menu li a', .6, { ease: Cubic.easeInOut, y: '0%' }, 0.06, '-=0.7')
    this.tl.to( this.$el.querySelector('.round-button'), .5, { ease: Cubic.easeInOut, opacity: 1 }, '-=0.4' )
    this.tl.to( this.$el.querySelector('.menu__footer'), .5, { ease: Cubic.easeInOut, opacity: 1 }, '-=0.2')
    this.tl.pause()

  },
};
</script>
